const ThankYou = () => {
  return (
    <div id="thankyou">
      <h3>Thank you for signing up</h3>
      <h4>
        You should receive your free Ebook in a few hours, check you email and
        your spam folder.
      </h4>
    </div>
  );
};

export default ThankYou;
